import { DefaultAuth, DefaultUrlApi } from "./Configuration";

import axios from "axios";

export const defaultResponseTransformers = () => {
  const { transformResponse } = axios.defaults;
  if (!transformResponse) return [];
  else if (transformResponse instanceof Array) return transformResponse;
  else return [transformResponse];
};

const http = axios.create({
  baseURL: DefaultUrlApi,
  timeout: 30000,
});

http.interceptors.response.use(
  function (response) {
    return response;
  },

  function (error) {
    const UNAUTHORIZED_REQUEST = 401;

    if (error.response.status === UNAUTHORIZED_REQUEST) {
      window.location.href = "/welcome";
    }

    return Promise.reject(error);
  }
);

export function setTokenFromSessionStorage() {
  const userData = JSON.parse(
    localStorage.getItem(`oidc.user:${DefaultAuth}:MG-RJS-SanaCash-Trader`)
  );
  const tokenFromSessionStorage = userData?.["access_token"];
  const tokenType = userData?.["token_type"];

  http.defaults.headers.common[
    "Authorization"
  ] = `${tokenType} ${tokenFromSessionStorage}`;
}

setTokenFromSessionStorage();

export function setBearerToken(token) {
  if (token === null) delete http.defaults.headers.common["Authorization"];
  else http.defaults.headers.common["Authorization"] = `Bearer ${token}`;
}

export default http;
